import React from "react";
import { Datagrid, List, TextField, useLocaleState } from "react-admin";

const FormsList = () => {
  const [locale] = useLocaleState();

  return (
    <List pagination={false}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField label="forms.title" source={`formSubtitle.${locale}`} />
      </Datagrid>
    </List>
  );
};

export default FormsList;
